<!--
Copyright (C) 2020 Reciprocity, Inc - All Rights Reserved
Unauthorized use, copying, distribution, displaying, or public performance
of this file, via any medium, is strictly prohibited. All information
contained herein is proprietary and confidential and may not be shared
with any third party without the express written consent of Reciprocity, Inc.
-->

<template>
  <zen-ellipsis v-if="groups.length">
    <div v-for="group in groups" :key="group.node.id" class="groups">
      <a
        v-b-tooltip.html.hover="{ customClass: 'info-tooltip', offset: '0, 5' }"
        :title="tooltipText(group)"
        :href="`/sor/info/${group.node.id.replace(':', '/')}/info`"
        target="_blank"
        class="group"
      >
        <div :class="isPrivate(group) ? 'single-user-icon' : 'multiple-user-icon'">
          <div class="mask"></div>
        </div>
        {{ title(group) }}
      </a>
    </div>
  </zen-ellipsis>
</template>

<script>
import Vue from 'vue';
import { ZenEllipsis } from 'zenComponents';
import { VBTooltip } from 'bootstrap-vue';

export default Vue.extend({
  name: 'GroupCellPresenter',
  components: {
    ZenEllipsis,
  },
  directives: {
    BTooltip: VBTooltip,
  },
  computed: {
    groups() {
      if (!this.$attrs.data || !this.$attrs.data.value) {
        return [];
      }

      return this.$attrs.data.value.edges;
    },
  },
  methods: {
    isPrivate(groupEdge) {
      return groupEdge.node.isPrivate.value;
    },
    groupPeopleCount(group) {
      return group.node.people.value.totalCount;
    },
    title(group) {
      const toPrivateGroupTitle = group => {
        const groupTitle = group.node.title.value;
        const person = group.node.people.value.edges[0].node;

        return person.name.value || groupTitle;
      };
      const toGroupTitle = group => group.node.title.value;

      return this.isPrivate(group) ? toPrivateGroupTitle(group) : toGroupTitle(group);
    },
    tooltipText(group) {
      return this.isPrivate(group) ? this.tooltipPrivateGroupText(group) : this.tooltipGroupText(group);
    },
    tooltipGroupText(group) {
      const title = group.node.title.value;
      const peopleCount = this.groupPeopleCount(group);

      return `
        <h1 class="info-tooltip--title">${title || ''}</h1>
        <p class="info-tooltip--code">${peopleCount} users</p>
      `;
    },
    tooltipPrivateGroupText(group) {
      const person = group.node.people.value.edges[0];

      const name = person.node.name && person.node.name.value;
      const email = person.node.email && person.node.email.value;

      if (!email) return '';

      return `
        <h1 class="info-tooltip--title">${name || ''}</h1>
        <p class="info-tooltip--code">${email}</p>
      `;
    },
  },
});
</script>

<style lang="scss" scoped>
// TODO: We need to refactor the ellipsis a bit to get this done better
@import '~legacy/_general/ellipsis_toggle/ellipsis_toggle';
@include ellipsis-toggle(1.75rem);

.groups {
  @import '@/legacy/assets/sor/object_info.scss';
}

.group {
  display: inline-flex;
  align-items: center;
  flex-grow: 1;
}
</style>
